import { msalInstance, loginRequest } from "../config/msal.config";
import { authenticateLogin } from './authentication.service';
import { getOrganisations } from './organisation.service';

export const getMsalProfilePhoto = async () => {
    try {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0) return null;

        const tokenResponse = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
        });

        const response = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
            headers: {
                Authorization: `Bearer ${tokenResponse.accessToken}`,
            },
        });

        if (!response.ok) return null;

        const blob = await response.blob();
        return URL.createObjectURL(blob);
    } catch {
        return null;
    }
};

export const microsoftLogin = async (setAuthenticated, setUser, user, toast, tenantId = '') => {
    try {
        let loginResponse;
        if (tenantId.trim()) {
            const loginOptions = {
                ...loginRequest,
                authority: `https://login.microsoftonline.com/${tenantId}`
            }
            loginResponse = await msalInstance.loginPopup(loginOptions);
        } else {
            const accounts = msalInstance.getAllAccounts();

            if (accounts.length > 0) {
                try {
                    loginResponse = await msalInstance.acquireTokenSilent({
                        ...loginRequest,
                        account: accounts[0]
                    });
                } catch (error) {
                    loginResponse = await msalInstance.acquireTokenPopup(loginRequest);
                }
            } else {
                loginResponse = await msalInstance.loginPopup(loginRequest);
            }
        }
        const authResponse = await authenticateLogin(loginResponse.accessToken);
        if (authResponse.status === 200) {
            setUser({ ...user, ...authResponse.data.data });
            const orgResponse = await getOrganisations(authResponse.data.data.token);
            if (orgResponse.status === 200) {
                const selectedOrganisation = orgResponse.data.data[0];
                const picture = await getMsalProfilePhoto();
                setUser({
                    ...user,
                    ...authResponse.data.data,
                    organisationId: selectedOrganisation.id,
                    organisationName: selectedOrganisation.name,
                    organisations: orgResponse.data.data,
                    ...(picture ? { picture } : {}),
                });
                setAuthenticated(true);
            }
        } else {
            throw new Error('Authentication Error: Unable to authenticate user');
        }
    } catch (error) {
        toast({
            title: "Error",
            description: "Error logging in: " + error,
            variant: "destructive",
        });
    }
};